import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';

export interface DialogData {
  env?: any;
  id?: string;
  title?: string;
  defaultImpolite?: boolean;
  text?: string;
  cancelName?: string;
  showNameInput?: boolean;
  nameInput?: string;
  singleAction?: string;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
  showDisableUnsavedChangesWarningCheckbox?: boolean;
  disableUnsavedChangesWarningCheckboxLabel?: string;
}

@Component({
  selector: 'confirmation',
  templateUrl: 'confirmation.component.html',
  styleUrls: ['confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialog {
  data$ = new BehaviorSubject<DialogData>(this.data);
  disableUnsavedChangesWarningCheckbox = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  ngOnInit() {
    // Update data$ if data changes
    this.data$.next(this.data);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  updateNameInput(value: string): void {
    const currentData = this.data$.value;
    this.data$.next({ ...currentData, nameInput: value });
  }

  updateDisableUnsavedChangesWarningCheckbox(value: boolean): void {
    this.disableUnsavedChangesWarningCheckbox = value;
  }

  getDialogCloseValue():
    | string
    | { allow: true; disableUnsavedChangesWarning: boolean }
    | undefined {
    const currentData = this.data$.value;
    if (currentData.showDisableUnsavedChangesWarningCheckbox) {
      return {
        allow: true,
        disableUnsavedChangesWarning: this.disableUnsavedChangesWarningCheckbox,
      };
    }
    if (currentData.showNameInput) {
      return currentData.nameInput;
    }
    return currentData.id;
  }
}
